import { HTMLAttributes } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { cn } from '@/lib/utils';

type ImageProps = {
	imageSrc: string;
	alt: string;
};

type AvatarSize = 'xxl' | 'lg' | 'md' | 'sm';

export interface AvatarProps extends HTMLAttributes<HTMLImageElement> {
	size: AvatarSize;
	image?: ImageProps;
	fallback: string;
	className?: string;
}

const FoundationAvatar = ({
	image,
	fallback,
	className,
	size,
	...rest
}: AvatarProps) => {
	return (
		<Avatar
			className={cn(`${className ?? ''} wlcb-text-body`, {
				'wlcb-size-20 wlcb-text-heading-2': size === 'xxl',
				'wlcb-size-12 wlcb-text-heading-3': size === 'lg',
				'wlcb-size-10': size === 'md',
				'wlcb-size-8 wlcb-text-caption': size === 'sm',
			})}
		>
			{image ? (
				<AvatarImage
					src={image.imageSrc}
					alt={image.alt}
					{...rest}
				/>
			) : null}
			<AvatarFallback>{fallback}</AvatarFallback>
		</Avatar>
	);
};

export default FoundationAvatar;
